import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stageGateApi } from "./api/service";

// checklist mutations
export const useAddCheckList = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ payload }: {
            payload: {
                task_name: string | null,
                user_id: number | null,
                is_evidence_required: boolean,
                is_required: boolean,
                object_type: string | null;
                object_id?: number | null;
                description?: string | null,
                priority?: string | null,
                status?: string | null,
                target_date?: string | null,
            }
        }) => {
            return await stageGateApi.addCheckList(payload);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useEditCheckList = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ payload, checkListID }: {
            payload: {
                task_name: string | null,
                user_id: number | null,
                is_evidence_required: boolean,
                is_required: boolean,
                object_type: string | null;
                object_id?: number | null;
                description?: string | null,
                priority?: string | null,
                status?: string | null,
                target_date?: string | null,
            }
            , checkListID: string
        }) => {
            return await stageGateApi.editCheckList(payload, checkListID);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useFetchChecklists = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ search_term, object_type, object_id, my_tasks, page, limit, priorityFilter, statusFilter }: { search_term: string | null, object_type: string, object_id: number | null, my_tasks: boolean; page?: number, limit?: number, priorityFilter?: string, statusFilter?: string }) => {
            return await stageGateApi.fetchCheckLists({ search_term, object_type, object_id, my_tasks, page, limit, priorityFilter, statusFilter });
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useFetchChecklistsDetails = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (checkListID: string) => {
            return await stageGateApi.fetchCheckListsDetails(checkListID);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};


export const useUpdateChecklists = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ checkListID, payload }: { checkListID: string, payload: { status: string, object_type: string, object_id?: number | string | null; notes?: string | null } }) => {
            return await stageGateApi.updateCheckLists(checkListID, payload);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

// approval mutations

export const useAddApprovals = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ stageID, payload }: { stageID: string, payload: { user_id: number, is_decision_gate: boolean } }) => {
            return await stageGateApi.addApproval(stageID, payload);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useFetchApprovals = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ stageID }: { stageID: string }) => {
            return await stageGateApi.fetchApprovals(stageID);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useEditApprovals = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ stageID, payload, approvalID }: { stageID: string, payload: { user_id: number, is_decision_gate: boolean }, approvalID: string }) => {
            return await stageGateApi.editApproval(stageID, payload, approvalID);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useUpdateApprovals = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ stageID, approvalID, payload }: { stageID: string, approvalID: string, payload: { status: string, notes: null | string } }) => {
            return await stageGateApi.updateApproval(stageID, approvalID, payload);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};